import { CustomTableData, TooltipInformation } from 'common'
import { MenuOptions } from './Dropdown'  // ✅ aquí

export const CollateralTable = ({ useFetchInit }) => {
  const { globalStates, FetchData, Actions, Forms } = useFetchInit;

  const { fetchAllCollateral: { collateral } } = FetchData;
  const { formOpeningMode } = globalStates;
  const { FormRequestGlobal: { formState } } = Forms;

  const columnConfig = [
    {
      headerName: "Info",
      maxWidth: 80,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellRenderer: (params) => {
        const { idvehicledeposit, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data;
        return (
          <TooltipInformation
            idregistro={idvehicledeposit}
            usuario_creo={usuario_creo}
            fecha_creo={fecha_creo}
            usuario_modifico={usuario_modifico}
            fecha_modifico={fecha_modifico}
          />
        );
      }
    },
    { field: "type_collateral", headerName: "TIPO DE GARANTIA", minWidth: 300, filter: true },
    { field: "title", headerName: "TITLE", minWidth: 500, filter: true },
    { field: "valor", headerName: "VALOR (Q)", minWidth: 130, filter: true },
    {
      headerName: "OPCIONES",
      minWidth: 300,
      cellRenderer: (params) => {
        const canEdit =
          formState.aprobacion_check === 'Pendiente Contrato' &&
          formOpeningMode === 'EDITABLE';

        return (
          <MenuOptions
            params={params}
            Actions={Actions}
            formOpeningMode={canEdit ? 'EDITABLE' : 'READONLY'}
          />
        );
      }
    },
  ];

  return (
    <div className='content'>
      <CustomTableData rowConfig={collateral} columnConfig={columnConfig} />
    </div>
  );
};
